const dispatchRoutes = {};
const registerDispatchRoute = (type, { render, variables }) => {
  dispatchRoutes[type] = {
    render,
    variables,
  };
};

export default dispatchRoutes;
export { registerDispatchRoute };
